export const frontmatter = {
  title: "Introducing, Scale.Farm",
  date: "2025-08-30",
  description: "A new era begins ― Trenches.Fund is launching Scale.Farm",
  category: "news",
}

## NEWS from the frontline!

Deep in the trenches by [Trenches.Fund](https://www.trenches.fund/)

Trenches.Fund has wholly acquired Scale™ in a mutually beneficial deal with Equalizer. The deal is structured in a way that lets the Equalizer team focus on Sonic, dedicating towards MEGA: Make Equalizer Great Again, while we craft a better future for every SCALE holder in the trenches!

![](https://scale.farm/scale/scale-police-banner.png)

As part of the takeover process, the new Scale treasury has received $30,000 in USDC along with all the SCALE, veSCALE & SCALE LP from Equalizer's Treasury. We also received complete ownership to all the code, infrastructure & other related hard & soft assets such as socials, other accounts and everything else.

Equalizer on Sonic will get read access to all the updates (we've already been working on closely) made to the existing Equalizer v5 frontend codebase, including the Manual CL UI, from the new Scale Team, until Scale migrates to a newer app. The ownership of all the remaining USDC, ETH & OP, including grants from Optimism Foundation, held by the previous Equalizer Treasury on Base shall remain with Equalizer Treasury. This ensures ample cash reserves to help fund future needs of Equalizer Team on Sonic.

All-in-all, this new arrangement will make Equalizer much stronger than before. It frees up resources from maintaining presence on Base to channel all efforts on gaining back its market share on Sonic.

We want to say a special Thank You to Hoops and the Equalizer team for the guidance & making this deal possible.

A long list of changes has been lined up for improving Scale's financial model, aimed towards sustainable long-term value preservation. This is especially important as we enter the Tail Emissions phase at the onset of our 3rd Year in the coming weeks.

Exciting times & more alpha ahead!
